import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export function getFileSizeInMB(file) {
  if (!file || !file.size) {
    return 0;
  }
  const sizeInMB = file.size / (1024 * 1024);
  return sizeInMB.toFixed(2); // Returns size in MB with 2 decimal places
}

export function getFileSizeInKB(file) {
  if (!file || !file.size) {
    return 0;
  }
  const sizeInKB = file.size / 1024;
  return sizeInKB.toFixed(2); // Returns size in KB with 2 decimal places
}

export function getFileExtension(file) {
  if (!file || !file.name) {
    return null;
  }
  const parts = file.name.split(".");
  const extension = parts.length > 1 ? parts.pop().toLowerCase() : "";
  const validExtensions = ["jpg", "jpeg", "png", "bmp"];
  return validExtensions.includes(extension) ? extension : null;
}

export const statusWithdraw = () => {
  return [
    {
      id: 0,
      name: "-- All --",
    },
    {
      id: 1,
      name: "pending",
    },
    {
      id: 2,
      name: "done",
    },
    {
      id: 3,
      name: "fail",
    },
  ];
}; // <-- Missing closing bracket added

export function isTokenExpired(token) {
  if (!token) {
    return true;
  }
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    //const expiryDate = new Date(payload.exp * 1000);
    //alert("Token Expiry Date: " + expiryDate.toLocaleString());
    return payload.exp < currentTime;
  } catch (error) {
    console.error("Invalid token format:", error);
    return true;
  }
}

// export pdf and excel file
export default class fileExporter {
  /**
   *
   * @param {Object} options
   * @param {string} options.fileName - PDF file name
   * @param {string} options.title - PDF title above the table
   * @param {Array} options.columns - Array of objects: [{ label: "Name", key: "name" }]
   * @param {Array} options.data - Array of row data
   * @param {Function} options.formatDate - Function to format date strings
   * @param {Array} options.dateFields - Array of keys that should be date-formatted
   */
  static exportToPdf({
    fileName = "Export.pdf",
    title = "Report",
    columns = [],
    data = [],
    formatDate = (val) => val,
    dateFields = [],
  }) {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // Title
    doc.setFontSize(14);
    doc.setFont("Roboto", "bold");
    doc.text(title, doc.internal.pageSize.getWidth() / 2, 15, {
      align: "center",
    });

    // Exported date (top-left)
    const exportDate = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(new Date());
    doc.setFontSize(10);
    doc.setFont("Roboto", "normal");
    doc.text(`Exported on: ${exportDate}`, 5, 32);

    // Headers (add S.No)
    const headers = ["No.", ...columns.map((col) => col.label)];
    console.log(data[0]);
    // Rows
    const rows = data.map((row, index) => [
      index + 1,
      ...columns.map((col) => {
        let value = row[col.key];
        if (value == null) return "";
        if (dateFields.includes(col.key)) {
          return formatDate(value);
        }
        return value;
      }),
    ]);

    // Table
    autoTable(doc, {
      head: [headers],
      body: rows,
      startY: 35,
      styles: {
        fontSize: 8,
        font: "Roboto",
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [0, 102, 204],
        textColor: 255,
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      margin: { top: 10, bottom: 10, left: 5, right: 5 },
      tableWidth: "auto",
    });

    doc.save(fileName);
  }

  static exportToExcel({
    fileName = "Export.xlsx",
    sheetName = "Sheet1",
    data = [],
    columns = [],
    formatDate = (v) => v,
    dateFields = [],
  }) {
    const exportData = data.map((row) => {
      const formatted = {};
      for (const col of columns) {
        let value = row[col.key];
        if (value == null) {
          formatted[col.label] = "";
        } else if (dateFields.includes(col.key)) {
          formatted[col.label] = formatDate(value);
        } else {
          formatted[col.label] = value;
        }
      }
      return formatted;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, fileName);
  }
}
